import { render, staticRenderFns } from "./ColForm.vue?vue&type=template&id=08b4ae1c&scoped=true&"
import script from "./ColForm.vue?vue&type=script&lang=js&"
export * from "./ColForm.vue?vue&type=script&lang=js&"
import style0 from "./ColForm.vue?vue&type=style&index=0&id=08b4ae1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b4ae1c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VAlert,VBtn})
